import type { NounKeys } from '../constants/nouns';
import {
	type ProductKeys,
	ProductKeys as ProductKeysObject,
} from '../constants/products';

/**
 * Determines whether nouns/datasources should be shown based on the available
 * products and noun configuration.
 */
export function getShouldShowNouns(
	isNounsAvailable: boolean,
	availableNouns: NounKeys[],
	availableProducts: ProductKeys[],
): boolean {
	return (
		isNounsAvailable ||
		availableNouns.length > 0 ||
		availableProducts.includes(ProductKeysObject.AtlassianWebCrawler)
	);
}
